import React from 'react';

const EneagramaEmpresas = () => {
    return (
        <div className="section-container">
            <h2>Eneagrama para Empresas</h2>
            <p>
                El Eneagrama en las Empresas: una herramienta clave para el éxito organizacional.
            </p>
            <p>
                El Eneagrama es mucho más que una herramienta de autoconocimiento. Aplicado a las empresas, se convierte en un recurso poderoso 
                para mejorar la gestión del talento, la comunicación y la productividad. Entre otros muchos beneficios, el Eneagrama en las empresas:
            </p>
            <ul>
                <li>💬 Mejora la comunicación y la colaboración</li>
                <li>🌟 Potencia el liderazgo y la Gestión de Equipos</li>
                <li>🔍 Optimiza la Selección y Retención del Talento</li>
                <li>🚀 Impulsa el Desarrollo Personal y Profesional</li>
                <li>🤝 Facilita la Resolución de Conflictos</li>
                <li>💡 Fomenta la Innovación y la Creatividad</li>
                <li>📈 Incrementa la Productividad y la Motivación</li>
            </ul>
            <p>
                Por todo ello, acompaño a las empresas para aplicar este mapa de la personalidad al éxito organizacional y a la creación de un clima laboral 
                basado en la autenticidad en las relaciones entre toda la comunidad empresarial, en la que todos lo más alineados posibles en una misma dirección.
            </p>
            <h3>Programas específicos:</h3>
            <ul>
                <li>🔥 Motivación y Desarrollo Organizacional</li>
                <li>🎯 Comunicación, Influencia Positiva y Liderazgo</li>
                <li>📝 Consultoría y Recursos Humanos</li>
                <li>🌱 Mentoring y Gestión del Talento</li>
            </ul>
            <p>
                ¿Quieres aplicar el Eneagrama en tu empresa? Desde EneaCoaching Profesional personalizo talleres, charlas y programas que puedan abarcar 
                todas estas áreas y que puedan satisfacer las necesidades de tu empresa.
            </p>
            
            <button
            className="btn-contacto"
            onClick={() => {
                window.open(
                "https://wa.me/34696667110?text=Hola. Quisiera información sobre Enegrama para empresas.",
                "_blank"
                );
            }}
            >
            Consulta
            </button>  
            
        </div>
    );
};

export default EneagramaEmpresas;
